import { IRequest } from '@r1-frontend/shared/types/IRequest';

interface IValidate {
    phone: string,
    code: string,
}

/*
* Проверка валидации телефона по коду
* https://master.phone-validator.sandbox.d2c.r-one.io/docs/#/validation/ValidationController_validate
* */
export const validate = (queryParams: IValidate): IRequest => ({
    uri: '/validation/validate',
    method: 'GET',
    queryParams,
});
